import MatchRoad from '@Components/MatchComponents/MatchRoad'
import Button from '@Components/Buttons/Button'
import React from 'react'
import Popup from '@App/kit/components/Popups/Popup'
import Pluralize from 'pluralize'

interface MatchWorksPopupProps {
    recordingGroupsCount: number
    onCancel: () => void
    onContinue: () => void
}

const MatchWorksPopup = (props: MatchWorksPopupProps) => {
    const { recordingGroupsCount, onCancel, onContinue } = props
    return (
        <Popup onClose={onCancel}>
            <div className="modal-content">
                <h2>Let&apos;s continue matching recordings.</h2>
                <p>To complete this process, you&apos;ll move through two steps:</p>
                <MatchRoad step={0} />
                <h5>
                    In the next step, you&apos;ll locate the work in your catalog that you&apos;d like to match with the{' '}
                    {Pluralize('selected recording group', recordingGroupsCount, true)}.
                </h5>
                <div className="button-row">
                    <Button mainColor type="secondary" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button mainColor type="primary" onClick={onContinue}>
                        Continue
                    </Button>
                </div>
            </div>
        </Popup>
    )
}

export default MatchWorksPopup
